<template>
  <div class="ads-put-in-key">
    <div class="header-box">
      <span class="header-label">日期</span>
      <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small"
                      value-format="yyyy-MM-dd" style="width: 230px;">
      </el-date-picker>
      <el-button type="primary" size="small" @click="dialogFormVisible = true">添加关键词</el-button>
      <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
    </div>
    <el-dialog title="关键词信息" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="关键词" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.keywordText" autocomplete="off" @input="onKeywordsChange"></el-input>
          <div>备注：多个关键词以英文逗号隔开</div>
        </el-form-item>
        <el-form-item label="投放类型" :label-width="formLabelWidth">
          <el-radio-group v-model="form.matchType">
            <el-radio :label="1">精准查询</el-radio>
            <el-radio :label="2">短语查询</el-radio>
            <el-radio :label="3">模糊查询</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="竞价" :label-width="formLabelWidth">
          <el-input v-model="form.bid" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addKeyWords">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量修改竞价" :visible.sync="bidBatchEditVisible" width="300px">
      <el-form>
        <el-form-item label="竞价" :label-width="formLabelWidth">
          <el-input v-model="batchUpdateOfBid" autocomplete="off" style="width: 100px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bidBatchEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateKeyWordBidListByAdGroupId(batchUpdateOfBid)">确 定</el-button>
      </div>
    </el-dialog>
    <ads-table :tableData="tableData" :theadList="theadList" @switch-change="switchChange"
               @head-switch-change="updateKeyWordStatusListByAdGroupId" @input-change="inputChange"
               @head-text-button-click="bidBatchEditVisible = true" >
    </ads-table>
  </div>
</template>

<script>
  import adsTable from '_c/table'
  import {adsModules} from '@r'

  export default {

    data() {
      return {
        form: {
          keyWords: null,
          matchType: 1,
          keywordText: "",
          bid: ""
        },
        batchUpdateOfBid: "",
        bidBatchEditVisible: false,
        dialogFormVisible: false,
        formLabelWidth: '100px',
        tableData: [],
        overallStatus: 2,
        theadList: [
          {
            id: '1',
            propName: 'index',
            width: '34px',
            labelName: '序号',
            textAlign: "center",
          },
          {
            id: '2',
            propName: 'status',
            labelName: '有效',
            width: '53px',
            showSwitch: true,
            showHeadSwitch: true,
            overallStatus: this.overallStatus,
            activeValue: 1,
            inactiveValue: 2,
            headActiveValue: 1,
            headInactiveValue: 2,
          },
          {
            id: '3',
            propName: 'content',
            labelName: '关键词'
          },
          {
            id: '15',
            propName: 'rankOfKeyword',
            labelName: '关键词排名',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.rankOfKeyword) - parseFloat(rowB.rankOfKeyword);
            },
            width: '64px',
          },
          {
            id: '12',
            propName: 'rankOfMolova',
            width: '40px',
            labelName: '本品排名',
            textAlign: "right",
          },
          {
            id: '13',
            propName: 'rankOfCompetitionProduct',
            width: '40px',
            labelName: '竞品排名',
            textAlign: "right",
          },
          {
            id: '14',
            propName: 'asinOfCompetitionProduct',
            labelName: '竞品asin'
          },
          {
            id: '4',
            propName: 'matchTypeText',
            labelName: '匹配类型'
          },
          {
            id: '3-1',
            propName: 'impressions',
            labelName: '曝光量',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.impressions) - parseFloat(rowB.impressions);
            },
            width: '55px',
          },
          {
            id: '3-2',
            propName: 'clicks',
            labelName: '点击数',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.clicks) - parseFloat(rowB.clicks);
            },
            width: '55px',
          },
          {
            id: '3-3',
            propName: 'clickRate',
            labelName: '点击率',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.clickRate) - parseFloat(rowB.clickRate);
            },
            width: '64px',
          },
          {
            id: '5',
            propName: 'servingStatus',
            labelName: '状态',
            width: '48px',
          },
          {
            id: '6',
            propName: 'bid',
            labelName: '竞价',
            showInput: true,
            textAlign: "right",
            sortable: true,
            showHeadTextButton: true,
            headTextButtonName: "批量修改",
            headTextButtonSize: "mini",
            sortMethod: function (rowA, rowB){
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.bid)-parseFloat(rowB.bid);
            }
          },
          {
            id: '11',
            propName: 'averageSpend',
            labelName: '平均点击单价',
            width: '53px',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.averageSpend) - parseFloat(rowB.averageSpend);
            }
          },
          {
            id: '7',
            propName: 'spend',
            labelName: '花费',
            width: '59px',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.spend) - parseFloat(rowB.spend);
            }
          },
          {
            id: '8',
            propName: 'orders',
            labelName: '订单数',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.orders) - parseFloat(rowB.orders);
            }
          },
          {
            id: '9',
            propName: 'sales',
            labelName: '销售额',
            width: '71px',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              return parseFloat(rowA.sales) - parseFloat(rowB.sales);
            }
          },
          {
            id: '10',
            propName: 'acos',
            labelName: 'ROAS',
            textAlign: "right",
            sortable: true,
            sortMethod: function (rowA, rowB) {
              if(rowA.status != rowB.status){
                return 0;
              }
              let subNumber = isNaN(parseFloat(rowA.acos)) ? 0 : parseFloat(rowA.acos);
              let nextNumber = isNaN(parseFloat(rowB.acos)) ? 0 : parseFloat(rowB.acos);
              return subNumber - nextNumber;
            },
          },
          {
            id: '16',
            propName: 'maintenanceMode',
            labelName: '手动维护',
            width: '48px',
            showSwitch: true,
            activeValue: 1,
            inactiveValue: 0,
          },
          {
            id: '17',
            propName: 'operateUserIdName',
            labelName: '操作人',
            width: '48px',
          },
          {
            id: '18',
            propName: 'errorLogSize',
            labelName: '错误报告',
            width: '55px',
            showErrorLink: true,
            businessType: 8,
          },
        ],
        groupId: null,
        adsType: null,
        date: [],
        pickerOptions: {
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              id: 'yesterday',
              text: '前一天',
              onClick: (picker) => {
                console.log(this);
                const end = this.date[0] || '';
                const start = this.date[1] || '';
                const newEnd = new Date(new Date(start).setTime(new Date(start).getTime() - 3600 * 1000 * 24))
                const newStart = new Date(new Date(end).setTime(new Date(end).getTime() - 3600 * 1000 * 24))
                picker.$emit('pick', [newStart, newEnd]);
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      }
    },
    components: {
      adsTable
    },
    created() {

    },
    activated() {
      this.groupId = this.$route.query.groupId - 0;
      const {beginDate, endDate} = this.$route.query;
      (beginDate || endDate) && (this.date = [beginDate, endDate]);
      this.form.bid = this.$route.query.defaultBid;
      this.queryAdsList()
    },
    mounted() {
    },
    methods: {
      onQueryBtnClick() {
        this.queryAdsList();
      },
      queryAdsList() {
        adsModules.getAdGroupKeywordList({
          params: {
            groupId: this.groupId,
            beginDate: this.date[0],
            endDate: this.date[1],
            dsTimeZone: 1
          }
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '错误'
            });
            return
          }
          this.tableData = res.ldata;
          this.theadList[1].overallStatus = res.mdata.alloverStatus;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      switchChange(porpName, val, scope) {
        if(porpName == "maintenanceMode"){
          adsModules.modifyMaintenanceMode({
            id: scope.row.id,
            type: 8,
            maintenanceMode: val,
          }).then((res) => {
            if (res.result !== 1) {
              this.$message({
                type: 'error',
                message: '编辑失败!'
              });
              return;
            }
            this.$message({
              type: 'success',
              message: '编辑成功!'
            });
            this.calculateStatus();
          }).catch((err) => {
            console.log(err)
          })
        } else if(porpName == "status") {
          adsModules.updateKeyWord({
            keywordId: scope.row.id,
            state: val
          }).then((res) => {
            if (res.result !== 1) {
              this.$message({
                type: 'error',
                message: '编辑失败!'
              });
              return;
            }
            this.$message({
              type: 'success',
              message: '编辑成功!'
            });
            this.calculateStatus();
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      resetSwitch() {
        newVal === 1 ? scope.row.status = 0 : scope.row.status = 1
      },
      inputChange(newVal, scope, propName, oldVal) {
        console.log('newVal:' + newVal + 'id:' + scope)
        adsModules.updateKeyWord({
          keywordId: scope.row.id,
          bid: newVal
        }).then((res) => {
          if (res.result !== 1) {
            this.resetInput(newVal, scope, propName, oldVal);
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑出错'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
        }).catch((err) => {
          this.resetInput(newVal, scope, propName, oldVal);
          this.$message({
            type: 'error',
            message: err.message ? err.message : '编辑出错'
          });
        })
      },
      resetInput(newVal, scope, propName, oldVal) {
        scope.row[propName] = oldVal;
      },
      addKeyWords() {
        this.$confirm('是否确认新增关键词投放?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          adsModules.insertKeywords({
            keywordText: this.form.keywordText,
            matchType: this.form.matchType,
            adGroupId: this.groupId,
            bid: this.form.bid
          }).then((res) => {
            this.dialogFormVisible = false;
            if (res.result !== 1) {
              this.$message({
                type: 'error',
                message: res.message ? res.message : '新增失败'
              });
              return;
            }
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.queryAdsList();
          }).catch((err) => {
            this.dialogFormVisible = false;
            this.$message({
              type: 'error',
              message: err.message ? err.message : '新增失败'
            });
          })
        }).catch(() => {
          this.dialogFormVisible = false
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      onKeywordsChange(value) {
        if (this.form.keywordText.indexOf("\n") >= 0) {
          var reg = /[\r\n]/g;
          this.form.keywordText = this.form.keywordText.replace(reg, ",");
          var lastIndex = this.form.keywordText.lastIndexOf(",");
          if (lastIndex == this.form.keywordText.length - 1) {
            this.form.keywordText = this.form.keywordText.substring(0, lastIndex);
          }
        }
      },
      updateKeyWordStatusListByAdGroupId(val, scope) {
        this.$confirm('此操作将改变所有关键词的状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          adsModules.updateKeyWordListByAdGroupId({
            adGroupId: this.groupId,
            state: val,
            operationType: 10,
          }).then((res) => {
            if (res.result !== 1) {
              this.$message({
                type: 'error',
                message: '编辑失败!'
              });
              return;
            }
            this.$message({
              type: 'success',
              message: '编辑成功!'
            });
            this.queryAdsList();
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
          this.theadList[1].overallStatus = this.theadList[1].overallStatus == 1? 2:1;
          this.$message({
            type: 'info',
            message: '已取消修改'
          });
        });
      },
      calculateStatus(){
        let tempStatus = 1;
        this.tableData.forEach(data =>{
          if(2 == data.status){
            tempStatus = 2;
          }
        });
        this.theadList[1].overallStatus = tempStatus;
      },
      updateKeyWordBidListByAdGroupId(val) {
        adsModules.updateKeyWordListByAdGroupId({
          adGroupId: this.groupId,
          bid: val,
          operationType: 11,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: '编辑失败!'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
          this.bidBatchEditVisible = false;
          this.queryAdsList();
        }).catch((err) => {
          console.log(err)
        })
      },
    }
  }
</script>

<style lang="scss">
  .header-box {
    .el-button {
      width: auto;
    }
  }
</style>
